import React from "react";
import {generateKey, isFunction} from "../../utils";
import * as PropTypes from "prop-types";
import {DatePicker, LocalizationProvider,} from '@mui/x-date-pickers';
import moment from "moment";
import {useTranslation} from "react-i18next";
import "moment/locale/fi";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

const CompDatePickerNew = (props) => {
    const key = generateKey('datepicker');

    let {label, isLabelShrink, error, value = null, id, disabled, onChange, canBeEmpty = false, ...componentProps} = props;
    const {t} = useTranslation('translation');

    const container = React.createRef();

    const handleDateChange = (date) => {
        console.log("received change", date)
        if (date === null) {
            if (canBeEmpty) {
                if (isFunction(onChange)) {
                    const data = {
                        target: {
                            ...componentProps,
                            value: null,
                            id: key,
                        },
                    };
                    onChange(data)
                }
            }
            return;
        }
        if (!date.isValid()) return;
        const format = "YYYY-MM-DD"
        if (isFunction(onChange)) {
            const data = {
                target: {
                    ...componentProps,
                    value: date.format(format),
                    id: key,
                },
            };
            onChange(data)
        }
    };

    const stringValueToDate = (stringValue) => {
        let value = moment.utc(stringValue);
        if(value.isValid()) return value;
        const date = moment.utc(stringValue, "YYYY-MM-DD");
        if (date.isValid()) return date;
        return null;

    };

    return (
        <div
            id={`comp-datepicker-container-${key}`}
            className={`comp-datepicker-container ${props.className ? 'container-' + props.className : ''} ${error ? 'error' : ''} ${disabled ? 'disabled': ''}`}
            ref={container}>

            {/* <div className={'label'}>{label}</div> */}
                <LocalizationProvider locale="fi" dateAdapter={AdapterMoment}>
                    <DatePicker
                        {...componentProps}
                        disabled={disabled}
                        disableToolbar
                        slotProps={{
                            textField: {
                                error: Boolean(error),
                                helperText: error ? t("errors." + error) : "",
                                InputLabelProps: {
                                    shrink: isLabelShrink
                                },
                                sx: {backgroundColor: "white",
                                    "& .MuiInputBase-root": {
                                        height: 39,
                                    },
                                    "& .MuiInputBase-input": {
                                        height: "100%",
                                        padding: "0 14px",
                                        boxSizing: "border-box"
                                    },
                                    ...(!disabled && {
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#404CE2",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#007FFF",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#007FFF",
                                        }
                                    })
                                },
                            }
                        }}
                        format="DD.MM.YYYY"
                        margin="normal"
                        label={label}
                        id={key}
                        value={stringValueToDate(value)}
                        helperText={error ? t("errors." + error) : error}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': { label },
                        }}
                        cancelLabel={t('common.cancel')}
                    />
            </LocalizationProvider>
        </div>
    );
}

CompDatePickerNew.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func
};

export {CompDatePickerNew};